import { SCALE_FACTOR } from "./constants";

export default class DetectionZones {
  isActive = false;
  maskFrame: any = null;
  diffFrame: any = null;

  elements: number = 0;

  private zone: MotionDetectionZone | null = null;
  private cv: any = null;
  private frameHeight: number = 0;
  private frameWidth: number = 0;

  setDetectionZone = (detectionZone: MotionDetectionZone | null) => {
    this.zone = detectionZone;
  };

  private createDetectionZoneMatrix = (
    gridMask: MotionDetectionZone["gridMask"],
    frameHeight: number,
    frameWidth: number
  ) => {
    try {
      const cv = this.cv;
      const { rows, cols, bits } = gridMask;

      const mask = cv.Mat.zeros(frameHeight, frameWidth, cv.CV_8UC1);
      cv.resize(mask, mask, new cv.Size(0, 0), SCALE_FACTOR, SCALE_FACTOR);

      const cellHeight = Math.floor(mask.rows / rows);
      const cellWidth = Math.floor(mask.cols / cols);

      for (let i = 0; i < bits.length; i++) {
        const cellIndex = bits[i];

        const row = Math.floor(cellIndex / cols);
        const col = cellIndex % cols;
        const startY = row * cellHeight;
        const endY = row === rows - 1 ? mask.rows : (row + 1) * cellHeight;
        const startX = col * cellWidth;
        const endX = col === cols - 1 ? mask.cols : (col + 1) * cellWidth;

        const roi = mask.roi(new cv.Rect(startX, startY, endX - startX, endY - startY));
        roi.setTo(new cv.Scalar(255));
        roi.delete();
      }

      const scaleFactor = cv.countNonZero(mask) / (mask.rows * mask.cols);

      this.maskFrame = mask;
      this.elements = Math.round(mask.rows * mask.cols * scaleFactor);

      log.motion("Created new detection zone mask frame", this.maskFrame, this.elements);
    } catch (e) {
      log.err("Failed to create detection zone", e);
    }
  };

  createMatrices = (cv: any, frameHeight: number, frameWidth: number) => {
    this.cv = cv;
    this.frameHeight = frameHeight;
    this.frameWidth = frameWidth;

    const gridMask = this.zone?.gridMask;
    if (!gridMask) return;

    log.motion("Creating new detection zone matrices");
    this.diffFrame = new cv.Mat();
    this.createDetectionZoneMatrix(gridMask, frameHeight, frameWidth);
    this.isActive = true;
  };

  updateMatrices = () => {
    if (!this.cv) {
      log.warn("Can't update detection zone, OpenCV is not ready");
      return;
    }
    this.deleteMatrices();
    this.createMatrices(this.cv, this.frameHeight, this.frameWidth);
  };

  deleteMatrices = () => {
    log.motion("Deleting detection zone matrices");
    this.maskFrame?.delete();
    this.diffFrame?.delete();
    this.maskFrame = null;
    this.diffFrame = null;
    this.elements = 0;
    this.isActive = false;
  };

  bitwiseAnd = (frame: any) => {
    if (!this.isActive) return;
    this.cv.bitwise_and(frame, this.maskFrame, this.diffFrame);
  };
}
